import { render, staticRenderFns } from "./CertificatesItem.vue?vue&type=template&id=23e16868&scoped=true"
import script from "./CertificatesItem.vue?vue&type=script&lang=js"
export * from "./CertificatesItem.vue?vue&type=script&lang=js"
import style0 from "./CertificatesItem.vue?vue&type=style&index=0&id=23e16868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e16868",
  null
  
)

export default component.exports